export default "__VITE_ASSET__BAhszGfm__"